import { render, staticRenderFns } from "./mediaViewerDialog.vue?vue&type=template&id=8885f50a&scoped=true"
import script from "./mediaViewerDialog.vue?vue&type=script&lang=js"
export * from "./mediaViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./mediaViewerDialog.vue?vue&type=style&index=0&id=8885f50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8885f50a",
  null
  
)

export default component.exports